"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactRedux = require("react-redux");
var _cccisdGraphqlTable = _interopRequireDefault(require("cccisd-graphql-table"));
var _admin = require("../../selectors/admin.js");
var _getQuery = require("./getQuery.js");
var _cccisdAxios = _interopRequireDefault(require("cccisd-axios"));
var _showLoader = _interopRequireDefault(require("./showLoader"));
var _cccisdNotification = _interopRequireDefault(require("cccisd-notification"));
var _cccisdConfirm = _interopRequireDefault(require("cccisd-confirm"));
var _getRoleHandlesFromDeploymentList = _interopRequireDefault(require("./getRoleHandlesFromDeploymentList.js"));
var _warning = _interopRequireDefault(require("cccisd-icons/warning"));
var _tableActions = _interopRequireDefault(require("./Exports/tableActions"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
var Boilerplate = window.cccisd.boilerplate;
var Fortress = window.cccisd.fortress;
var TABLE_METRICS_LIMIT = 500;
var STATUS_MAP = ['Not Started', 'In Progress', 'Complete'];
var forcedOrder = ['pawn.pawnId', 'user.username', 'user.firstName', 'user.lastName', 'user.fullName', 'user.fullNameWithEmail', 'user.fullNameWithUsername', 'user.email', 'user.phone', 'user.activated', 'user.hasLoggedIn', 'user.lastLoginDate', 'pawn.importId', 'pawn.createdDate', 'pawn.roleName'].reduce(function (obj, item, index) {
  obj[item] = index + 1;
  return obj;
}, {});
var MetricsDataTable = function MetricsDataTable(props) {
  var deploymentIds = props.deploymentIds,
    syncTableProps = props.syncTableProps,
    constantFilter = props.constantFilter,
    metrics = props.metrics,
    setMetricsToVisualize = props.setMetricsToVisualize,
    showCustomizeButton = props.showCustomizeButton,
    applyPawnContext = props.applyPawnContext,
    adjustColumns = props.adjustColumns;
  var project = (0, _reactRedux.useSelector)(function (state) {
    return (0, _admin.getCurrentProject)(state.assignment.admin);
  });
  var currentQuerySettings = (0, _reactRedux.useSelector)(function (state) {
    return (0, _admin.getPopulatedCurrentQuerySettings)(state.assignment.admin);
  });
  var deploymentList = (0, _reactRedux.useSelector)(function (state) {
    return (0, _admin.getCurrentQueryAssignmentActiveDeployments)(state.assignment.admin);
  });
  var projectFields = (0, _reactRedux.useSelector)(function (state) {
    return (0, _admin.getCurrentProjectFields)(state.assignment.admin);
  });

  // get identifiable fields
  var identifiableFields = (0, _react.useMemo)(function () {
    var roleHandles = (0, _getRoleHandlesFromDeploymentList["default"])(deploymentList.filter(function (item) {
      return deploymentIds.includes(item.deploymentId);
    }));
    var result = new Set();
    if (Fortress.hasAccess('quest.view_identifiable_data', project.groupId) || roleHandles.length === 0) {
      return result;
    }
    for (var _i = 0, _Object$values = Object.values(projectFields); _i < _Object$values.length; _i++) {
      var field = _Object$values[_i];
      if (field.isIdentifiable) {
        result.add(field.path);
      }
    }
    return window.cccisd.appDefs.pawn.roles.reduce(function (list, role) {
      if (roleHandles.includes(role.handle)) {
        (role.identifiableFields || []).forEach(function (field) {
          list.add(field);
        });
      }
      return list;
    }, result);
  }, [deploymentList, deploymentIds, project, projectFields]);
  var downloadFile = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(token) {
      var response;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            _context.n = 1;
            return _cccisdAxios["default"].post(Boilerplate.route('flow.api.entity.showFile'), {
              download: 0,
              filename: token
            });
          case 1:
            response = _context.v;
            window.open(response.data.data.url, '_blank');
          case 2:
            return _context.a(2);
        }
      }, _callee);
    }));
    return function downloadFile(_x) {
      return _ref.apply(this, arguments);
    };
  }();
  var _useMemo = (0, _react.useMemo)(function () {
      var newColumns = Object.values(currentQuerySettings.columns).filter(function (column) {
        var isIdentifying = identifiableFields.has(column.id) || identifiableFields.has('user.*') && /^user\./.test(column.id);
        return !isIdentifying;
      }).sort(function (a, b) {
        var aSort = forcedOrder[a.id] || a.sort + 100;
        var bSort = forcedOrder[b.id] || b.sort + 100;
        return aSort - bSort;
      }).map(function (column) {
        return {
          name: column.id,
          label: column.label,
          type: column.type,
          sticky: column.sticky,
          sort: true,
          filter: true,
          alignment: ['number', 'boolean'].includes(column.type) ? 'center' : 'left'
        };
      });
      var currentQueryMetrics = new Set(currentQuerySettings.metrics.list);
      var hasIdentifiablePermission = Fortress.hasAccess('quest.view_identifiable_data', project.groupId);
      var selectedMetrics = metrics.filter(function (item) {
        if (item.isIdentifying && !hasIdentifiablePermission) {
          return false;
        }
        if (currentQueryMetrics.has(item.reportHeader)) {
          return true;
        }
        if (currentQuerySettings.metrics.types.includes(item.type) && item.surveyHandles.some(function (handle) {
          return currentQuerySettings.surveyHandles.includes(handle);
        })) {
          return true;
        }
        return false;
      });
      var isLimitReached = selectedMetrics.length > TABLE_METRICS_LIMIT;
      var visibleMetrics = isLimitReached ? selectedMetrics.slice(0, TABLE_METRICS_LIMIT) : selectedMetrics;
      var tableColumns = function () {
        return [].concat(_toConsumableArray(newColumns.map(function (item) {
          return _objectSpread(_objectSpread({}, item), {}, {
            name: "pawn.".concat(item.name),
            sticky: item.sticky,
            render: function render(_ref2) {
              var value = _ref2.value;
              if (item.type === 'boolean' && typeof value === 'boolean') {
                return value ? 'Yes' : 'No';
              }
              return value;
            }
          });
        })), _toConsumableArray(currentQuerySettings.waveName ? [{
          name: 'deployment.label',
          label: 'Wave name',
          sort: true,
          filter: true
        }] : []), _toConsumableArray(currentQuerySettings.waveTimepoint ? [{
          name: 'deployment.timepoint',
          label: 'Wave timepoint',
          sort: true,
          filter: true
        }] : []), _toConsumableArray(currentQuerySettings.surveyLanguage ? [{
          name: 'language',
          label: 'Language',
          sort: true,
          filter: true
        }] : []), _toConsumableArray(currentQuerySettings.surveyList ? [{
          name: 'surveylist.surveylistHandle',
          label: 'Form',
          sort: true,
          filter: true
        }] : []), _toConsumableArray(currentQuerySettings.assignmentStatus ? [{
          name: 'status',
          label: 'Status',
          sort: true,
          filter: true,
          filterSettings: {
            type: 'selectbox',
            placeholder: '-- Choose one --',
            options: [{
              label: STATUS_MAP[0],
              value: STATUS_MAP[0]
            }, {
              label: STATUS_MAP[1],
              value: STATUS_MAP[1]
            }, {
              label: STATUS_MAP[2],
              value: STATUS_MAP[2]
            }]
          }
        }] : []), _toConsumableArray(visibleMetrics.map(function (item) {
          return _objectSpread(_objectSpread({
            name: "variables.".concat(item.reportHeader),
            label: item.reportHeader,
            tooltip: item.label || item.question || null,
            originalLabel: item.label,
            question: item.question,
            sort: true,
            filter: true,
            type: item.type,
            headerClassName: 'text-nowrap'
          }, item.isFile ? {
            className: 'text-center',
            hideInCsv: true
          } : {}), {}, {
            render: function render(_ref3) {
              var value = _ref3.value;
              if (item.isFile) {
                return value ? /*#__PURE__*/_react["default"].createElement("button", {
                  type: "button",
                  className: "btn btn-secondary btn-sm",
                  onClick: function onClick() {
                    return downloadFile(value);
                  }
                }, "Download") : null;
              }
              if (project && project.settings && project.settings.missingValues) {
                if (typeof value === 'undefined') {
                  // never encountered
                  if (item.type === 'quantitative') {
                    // quantitative
                    return project.settings.missingValues.quantitative.neverEncountered;
                  }
                  // qualitative
                  return project.settings.missingValues.qualitative.neverEncountered;
                }
                if (value === null) {
                  // declined to answer
                  if (item.type === 'quantitative') {
                    // quantitative
                    return project.settings.missingValues.quantitative.declinedToAnswer;
                  }
                  // qualitiative
                  return project.settings.missingValues.qualitative.declinedToAnswer;
                }
              }
              return value;
            } // just to not show warning in console
          });
        })));
      }();
      var newQuery = (0, _getQuery.getQuery)({
        columns: newColumns,
        filter: currentQuerySettings.filter,
        codedValues: currentQuerySettings.codedValues,
        includeIdentifiable: Fortress.hasAccess('quest.view_identifiable_data', project.groupId),
        applyPawnContext: applyPawnContext,
        onlyCompleted: currentQuerySettings.onlyCompleted,
        includeArchived: currentQuerySettings.includeArchived
      });
      var graphqlVariables = {
        deploymentId: deploymentIds,
        projectId: project.groupId,
        metrics: visibleMetrics.map(function (item) {
          return item.reportHeader;
        })
      };

      // prevent 504 Timeout when downloading very large CSV's
      var csvChunkSize = 500;
      if (tableColumns.length > 500) {
        csvChunkSize = 50;
      } else if (tableColumns.length > 200) {
        csvChunkSize = 200;
      }
      var currentAssignment = {
        assignmentId: currentQuerySettings.assignmentId,
        groupId: project.groupId
      };
      var tableColumReportHeaders = visibleMetrics.map(function (metric) {
        return metric.reportHeader;
      });
      var actualColumns = adjustColumns ? adjustColumns({
        columns: tableColumns,
        currentQuerySettings: currentQuerySettings
      }) : tableColumns;
      var variablesInColumns = actualColumns.reduce(function (set, item) {
        if (/^variables\./.test(item.name)) {
          set.add(item.name.slice(10));
        }
        return set;
      }, new Set());

      // visualize metrics expect for dates
      setMetricsToVisualize(visibleMetrics.filter(function (item) {
        return !['timestamp', 'date'].includes(item.questionType) && variablesInColumns.has(item.reportHeader);
      }).map(function (item) {
        return item.reportHeader;
      }));
      var result = {
        columns: actualColumns,
        csvChunkSize: csvChunkSize,
        csvHeaderRows: currentQuerySettings.csvHeaders || ['label'],
        query: newQuery,
        graphqlVariables: graphqlVariables,
        key: "".concat(project.groupId, ".metricsDataTable").concat(deploymentIds.join('.')),
        tableActions: (0, _tableActions["default"])(currentAssignment, tableColumReportHeaders)
      };
      if (Fortress.hasAnyAccess(['quest.modify_data', 'quest.admin'], project.groupId)) {
        result.rowActions = [{
          name: 'clearAssignment',
          title: 'Delete row of data permanently',
          action: function () {
            var _action = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(_ref4) {
              var selectedRows, loadData;
              return _regenerator().w(function (_context3) {
                while (1) switch (_context3.n) {
                  case 0:
                    selectedRows = _ref4.selectedRows, loadData = _ref4.loadData;
                    (0, _cccisdConfirm["default"])({
                      message: 'Are you sure?',
                      description: "Metrics for the selected respondents in selected data collection waves, along with all related survey progress, will be permanently deleted. This cannot be undone. Proceed?",
                      confirmLabel: 'Yes',
                      abortLabel: 'No'
                    }).then(function () {
                      function deleteRows() {
                        return _deleteRows.apply(this, arguments);
                      }
                      /* backend makes a Task Master if > 10 rows, so make sure
                          Loading Spinner does not coverup Task Master modal */
                      function _deleteRows() {
                        _deleteRows = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
                          return _regenerator().w(function (_context2) {
                            while (1) switch (_context2.n) {
                              case 0:
                                _context2.n = 1;
                                return _cccisdAxios["default"].post(Boilerplate.route('api.assignment.assignmentProgress.delete'), {
                                  assignmentProgressIds: selectedRows,
                                  targetedPermissionGroupId: project.groupId
                                });
                              case 1:
                                _context2.n = 2;
                                return loadData();
                              case 2:
                                (0, _cccisdNotification["default"])('Assignment progress has been successfuly cleared');
                              case 3:
                                return _context2.a(2);
                            }
                          }, _callee2);
                        }));
                        return _deleteRows.apply(this, arguments);
                      }
                      if (selectedRows.length <= 10) {
                        (0, _showLoader["default"])(deleteRows);
                      } else {
                        deleteRows();
                      }
                    }).fail(function () {
                      // do nothing
                    });
                  case 1:
                    return _context3.a(2);
                }
              }, _callee3);
            }));
            function action(_x2) {
              return _action.apply(this, arguments);
            }
            return action;
          }()
        }];
      }
      return [result, isLimitReached];
    }, [project, deploymentIds, currentQuerySettings, identifiableFields, metrics, adjustColumns]),
    _useMemo2 = _slicedToArray(_useMemo, 2),
    tableProps = _useMemo2[0],
    showLimitMessage = _useMemo2[1];
  var render = function render(_ref5) {
    var renderDefault = _ref5.renderDefault,
      filters = _ref5.filters,
      selectedRows = _ref5.selectedRows;
    syncTableProps({
      filters: filters,
      selectedRows: selectedRows
    });
    return renderDefault();
  };
  return /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      marginTop: '1em'
    }
  }, showLimitMessage && showCustomizeButton && /*#__PURE__*/_react["default"].createElement("div", {
    className: "text-center text-danger"
  }, /*#__PURE__*/_react["default"].createElement(_warning["default"], {
    spaceRight: true
  }), "Table is limited to ", TABLE_METRICS_LIMIT, " metrics. Use Customize button to select different metrics."), tableProps.columns ? /*#__PURE__*/_react["default"].createElement(_cccisdGraphqlTable["default"], _extends({}, tableProps, {
    rowKey: "assignmentProgressId",
    showDoubleScrollbar: true,
    isStickyHeader: true,
    render: render,
    constantFilter: constantFilter,
    csvSaveHeader: true
  })) : null);
};
MetricsDataTable.propTypes = {
  metrics: _propTypes["default"].array,
  deploymentIds: _propTypes["default"].array,
  constantFilter: _propTypes["default"].object,
  syncTableProps: _propTypes["default"].func,
  setMetricsToVisualize: _propTypes["default"].func,
  showCustomizeButton: _propTypes["default"].bool,
  adjustColumns: _propTypes["default"].func
};
var _default = exports["default"] = MetricsDataTable;